var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "ibox sombra-light" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "ibox-content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [_vm._v("Proveedor")]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [_vm._v("Metodo")]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [_vm._v("Codigo")]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [_vm._v("Estado")]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [_vm._v("Fecha")]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _vm._v(_vm._s(_vm.error.auditoria_integracion.proveedor.nombre)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _vm._v(_vm._s(_vm.error.auditoria_integracion.parametro.metodo)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [
            _vm._v(
              _vm._s(_vm.error.auditoria_integracion.id_codigo_integracion)
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [
            _vm._v(_vm._s(_vm.error.estado.nombre)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [
            _vm._v(_vm._s(_vm.error.auditoria_integracion.created_at)),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row ", staticStyle: { "margin-top": "100px" } },
          [
            _c("div", { staticClass: "col-5" }, [
              _vm._v("\n                    Request\n                "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-7" }, [
              _vm._v("\n                    Response\n                "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-5" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.error.auditoria_integracion.request) +
                  "\n                "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-7" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.error.auditoria_integracion.response) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Comentario")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.comentario,
                      expression: "comentario",
                    },
                  ],
                  staticClass: "mb-2",
                  attrs: { rows: "5", cols: "40" },
                  domProps: { value: _vm.comentario },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.comentario = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Estado")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.id_estado,
                        expression: "id_estado",
                      },
                    ],
                    staticClass: "custom-select custom-select-sm",
                    staticStyle: { width: "200px", height: "35px" },
                    attrs: { name: "type" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.id_estado = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.estado_disponibles, function (item, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: item.id } },
                      [_vm._v(_vm._s(item.nombre))]
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "offset-md-6 col-md-6" },
            [
              _c(
                "b-button",
                {
                  staticClass: "buscar-info-dashboard",
                  attrs: { block: "", variant: "primary" },
                  on: { click: _vm.save },
                },
                [_vm._v("Guardar")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [
        _c("i", { staticClass: "fal fa-chart-bar" }),
        _vm._v(" Detalles\n            "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }